import { logout } from '..';
import { apiSlice } from './apiSlice';

export interface AuthRole {
  id: number;
  name: 'USER' | 'ADMIN' | 'SUPER_ADMIN' | 'MASTER' | string;
}

export interface LoginResponse {
  success: boolean;
  accessToken: string | null;
  type: string;
  role: AuthRole;
  passwordChanged: boolean;
  // mfa
  userId?: number;
  mfaRequired?: boolean;
  isTelegramEnabled?: boolean;
}
interface LoginCredentials {
  username: string;
  password: string;
  device: string;
}

interface ResetPasswordCredentials {
  mobile: string;
  newPassword: string;
  code: string;
}

interface DemoLoginResponse {
  accessToken: string;
  type: string;
}

interface SendOTPResponse {
  mobile: {
    sentAt: string;
    timeout: number;
    attempt: number;
    maxAttempt: number;
  };
}

interface LogoutResponse {
  message: string;
  error: string;
  statusCode: number;
}

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginCredentials>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth', 'User'],
    }),
    loginDemoUser: builder.mutation<DemoLoginResponse, void>({
      query: () => ({
        url: '/auth/demo/login',
        method: 'POST',
      }),
      invalidatesTags: ['Auth', 'User'],
    }),
    sendOtp: builder.mutation<SendOTPResponse, { mobile: string; country: string; type: string }>({
      query: (credentials) => ({
        url: '/auth/send-code',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    forgotPassword: builder.mutation<SendOTPResponse, { mobile: string }>({
      query: (credentials) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    resetPassword: builder.mutation<{ status: string }, ResetPasswordCredentials>({
      query: (credentials) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    logout: builder.mutation<LogoutResponse, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
      invalidatesTags: ['Auth'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(apiSlice.util.resetApiState());
          dispatch(logout());
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useLoginDemoUserMutation,
  useSendOtpMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLogoutMutation,
} = authApi;
